import { defineMessages } from 'react-intl';

export default defineMessages({
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
  SCHEDULED: 'Scheduled',
  MISSING_POLICY: 'Missing policy',
  MISSING_LICENSE: 'No license',
  LICENSE_LIMIT: 'Over license limit',
});
